module.exports = __webpack_public_path__ + "img/loe_elg.6faf4a61.jpg";